import { useEffect, useState, useCallback } from "react";

import { Container, Grid, Card, Tab, AppBar } from "@material-ui/core";
import { Skeleton, TabContext, TabList } from "@material-ui/lab";

import BignumbersLogs from "./components/BignumbersLogs";
import CardAccessIndicators from "./components/CardAccessIndicators";
import CardTopUsersAccessChart from "./components/CardTopUsersCharts";
import TopFeaturesChart from "./components/CardTopFeaturesCharts";
import TableAccessLogs from "./components/TableAccessLogs";
import TableAccessLogsUser from "./components/TableAccessLogsUser";
import LoadingData from "components/Loading/LoadingData";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

import FilterCard from "components/_refactor/filter-card";
import HeaderClientes from "components/_refactor/headers/clients.js";
import AutoCompleteField from "components/_refactor/fields/autocomplete";

import Api from "lib/api/httpRequestHelper";
import moment from "moment";
import { format } from "date-fns";
import useLogs from "hooks/logs";
import { IsMobile, IsMobile900 } from "utils/is-mobile";
import PeriodField from "components/_refactor/fields/period-field";

function getPeriodParams(period, initDate, endDate, type) {
  if (period === "Outros") {
    return (
      (type === "user" ? "&dataInicial=" : "?dataInicial=") +
      moment(initDate).format("MM-DD-YYYY") +
      "&dataFinal=" +
      moment(endDate).format("MM-DD-YYYY")
    );
  }

  let dateP;
  dateP = new Date();
  dateP.setDate(dateP.getDate() - period);

  return (
    (type === "user" ? "&dataInicial=" : "?dataInicial=") +
    format(dateP, "MM'-'dd'-'yyyy") +
    "&dataFinal=" +
    format(new Date(), "MM'-'dd'-'yyyy")
  );
}

const listSystem = [
  {
    value: "PORTALB2B",
    name: "B2B",
    id: 1,
  },
  {
    value: "APP",
    name: "APP",
    id: 2,
  },
];

const dataHoje = new Date().toISOString().slice(0, 10);

function DashboardIndicadoresDeAcesso() {
  const snackbar = useSnackbar();
  const { setLocalStorageActions, setLocalStorageApiProblem } = useLogs();

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const itemXS4 = isMobile900 ? 12 : 4;
  const itemXS5 = isMobile ? 12 : isMobile900 ? 6 : 4;
  const itemXS3 = isMobile ? 12 : isMobile900 ? 6 : 3;

  const [valueTab, setValueTab] = useState("1");
  const [showFilters, setShowFilters] = useState(true);
  const [clearFilters, setClearFilters] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);

  const [loadingTableUser, setLoadingTableUser] = useState(false);
  const [loadingTableScreen, setLoadingTableScreen] = useState(false);
  const [loadingFilters, setLoadingFilters] = useState(false);
  const [searching, setSearching] = useState(false);

  const [errorMessageUserDataTable, setErrorMessageUserDataTable] =
    useState("");
  const [errorMessageScreenDataTable, setErrorMessageScreenDataTable] =
    useState("");

  const [period, setPeriod] = useState(30);
  const [initialDate, setInitialDate] = useState(dataHoje);
  const [finalDate, setFinalDate] = useState();

  const [selectedSystem, setSelectedSystem] = useState(null);

  const [screensList, setScreensList] = useState([]);
  const [screen, setScreen] = useState("");
  const [screenTableData, setScreenTableData] = useState(null);

  const [usersList, setUsersList] = useState([]);
  const [user, setUser] = useState("");
  const [userTableData, setUserTableData] = useState(null);

  const [bigNumbers, setBigNumbers] = useState([]);
  const [accessIndicators, setAccessIndicators] = useState([]);

  const [monthAccessIndicator, setMonthAccessIndicator] = useState([]);
  const [monthTop10Users, setMonthTop10Users] = useState([]);
  const [featuresMoreUsed, setFeatureMoreUsed] = useState([]);
  const [loadingFeaturesMoreUsed, setLoadingFeaturesMoreUsed] = useState(true);
  const [loadingMonthTop10Users, setLoadingMonthTop10Users] = useState(true);
  const [loadingMonthAccessIndicator, setLoadingMonthAccessIndicator] =
    useState(true);

  const [totalRegistersUser, setTotalRegistersUser] = useState(null);
  const [currentPageUser, setCurrentPageUser] = useState(null);
  const [currentSizePerPageUser, setCurrentSizePerPageUser] = useState(10);

  const handleGetTableData = async () => {
    setSearching(true);
    setLocalStorageActions({
      nomeTela: "Dashboard Indicadores de Acesso",
      idMenu: "142",
      acao: "Clicou para Pesquisar",
    });

    await handleGetUsersTableData();
    await handleGetScreensTableData();

    setSearching(false);
  };

  const handleGetFiltersData = async () => {
    setLoadingFilters(true);

    await handleGetScreens();
    await handleGetUsers();

    setLoadingFilters(false);
  };

  const handleGetBigNumbers = async () => {
    await Api.get("access-big-number", "log", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setBigNumbers(Result);
        }
      })
      .catch((error) => {
        setBigNumbers([]);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "142",
          screen: "Indicadores de Acesso",
          problem: `Erro na chamada do endpoint access-big-number - ${error}`,
        });
      });
  };

  const handleGetScreens = async () => {
    await Api.get("screen-list", "log", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setScreensList(Result);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "142",
          screen: "Indicadores de Acesso",
          problem: `Erro na chamada do endpoint screen-list - ${error}`,
        });
      });
  };

  const handleGetUsers = async () => {
    await Api.get("list-user", "adminportal", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setUsersList(Result);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "142",
          screen: "Indicadores de Acesso",
          problem: `Erro na chamada do endpoint list-user - ${error}`,
        });
      });
  };

  const handleGetMonthAccessIndicator = async () => {
    await Api.get("report-access-graph?tipoGrafico=M", "userAccess", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setMonthAccessIndicator([Result.IndicadorMensal]);
          console.log("indicators:", Result.IndicadorMensal);
          setLoadingMonthAccessIndicator(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "142",
          screen: "Indicadores de Acesso",
          problem: `Erro na chamada do endpoint month-access-indicator - ${error}`,
        });
      });
  };

  const HandleGetMonthTop10Users = async () => {
    await Api.get("report-access-graph?tipoGrafico=U", "userAccess", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setMonthTop10Users(Result.TopUsuariosAcesso.slice(0, 10));
          console.log("users:", Result.TopUsuariosAcesso.slice(0, 10));
          setLoadingMonthTop10Users(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "142",
          screen: "Indicadores de Acesso",
          problem: `Erro na chamada do endpoint month-top-10-users - ${error}`,
        });
      });
  };

  const HandleGetFeatureMoreUsed = async () => {
    await Api.get("report-access-graph?tipoGrafico=F", "userAccess", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setFeatureMoreUsed(Result.TopFuncionalidades.slice(0, 10));
          console.log("feature:", Result.TopFuncionalidades.slice(0, 10));
          setLoadingFeaturesMoreUsed(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "142",
          screen: "Indicadores de Acesso",
          problem: `Erro na chamada do endpoint feature-more-used - ${error}`,
        });
      });
  };

  const handleGetAccessIndicators = async () => {
    await Api.get("report-access-user", "userAccess", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setAccessIndicators(Result);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "142",
          screen: "Indicadores de Acesso",
          problem: `Erro na chamada do endpoint report-access-user - ${error}`,
        });
      });
  };

  const handleGetUsersTableData = useCallback(
    async (e, page = 1, pageSize = 10) => {
      setLoadingTableUser(true);
      setCancelLoading(false);
      setErrorMessageUserDataTable("");

      const hasUserSelected =
        user?.IdUsuario !== undefined ? `&idUsuario=${user?.IdUsuario}` : "";

      const hasSystemSelected = screen?.Sistema
        ? `&sistema=${screen?.Sistema}`
        : selectedSystem
        ? `&sistema=${selectedSystem?.value}`
        : "";

      const hasScreenSelected = screen?.Tela ? `&tela=${screen?.Tela}` : "";

      await Api.get(
        "log-access-user-list",
        "log",
        "?page=" +
          (page - 1) +
          "&pageSize=" +
          pageSize +
          hasUserSelected +
          hasScreenSelected +
          hasSystemSelected +
          getPeriodParams(period, initialDate, finalDate, "user"),
        true
      )
        .then((data) => {
          if (data?.Result?.ListaLogsUsuario?.length !== 0) {
            const newListUsers = [];
            let newObjectUser = {};
            // eslint-disable-next-line array-callback-return
            data?.Result?.ListaLogsUsuario?.map((user) => {
              newObjectUser = {
                DataHoraUltimoAcesso: user.DataHoraUltimoAcesso,
                IdUsuario: user?.IdUsuario,
                IdUser: Math.floor(Math.random() * (100000 - 5000 + 1)) + 5000,
                Nome: user.Nome,
                QuantidadeAcesso: user.QuantidadeAcesso,
                Sistema: user.Sistema,
                TelaMaisAcessada: user.TelaMaisAcessada,
                Login: user.Login,
              };
              newListUsers.push(newObjectUser);
            });
            setUserTableData(newListUsers);
            setTotalRegistersUser(data?.Result?.TotalRegistros);
          } else {
            setUserTableData([]);
            setTotalRegistersUser(null);
          }
        })
        .catch((e) => {
          setUserTableData(null);
          console.log(e);
          setErrorMessageUserDataTable(e);
          setLocalStorageApiProblem({
            idMenuAccess: "142",
            screen: "Indicadores de Acesso",
            problem: `Erro na chamada do endpoint log-access-user-list - ${e}`,
          });
        })
        .finally(() => {
          setCurrentPageUser(page);
          setCurrentSizePerPageUser(pageSize);
          setLoadingTableUser(false);
        });
    },
    [
      currentPageUser,
      currentSizePerPageUser,
      user,
      period,
      initialDate,
      finalDate,
      screen,
      selectedSystem,
    ]
  );

  const handleGetScreensTableData = async () => {
    setLoadingTableScreen(true);
    setCancelLoading(false);
    setErrorMessageScreenDataTable("");

    const hasScreenSelected = screen?.Tela ? `&tela=${screen?.Tela}` : "";

    const hasSystemSelected = screen?.Sistema
      ? `&sistema=${screen?.Sistema}`
      : selectedSystem
      ? `&sistema=${selectedSystem?.value}`
      : "";

    const hasUserSelected =
      user?.IdUsuario !== undefined ? `&idUsuario=${user?.IdUsuario}` : "";

    await Api.get(
      "log-access-screen-list",
      "log",
      getPeriodParams(period, initialDate, finalDate, "screen") +
        hasScreenSelected +
        hasSystemSelected +
        hasUserSelected,
      true
    )
      .then((data) => {
        setScreenTableData(data?.Result || []);
      })
      .catch((e) => {
        setScreenTableData(null);
        setErrorMessageScreenDataTable(e);
        console.log(e);
        setLocalStorageApiProblem({
          idMenuAccess: "142",
          screen: "Indicadores de Acesso",
          problem: `Erro na chamada do endpoint log-access-screen-list - ${e}`,
        });
      })
      .finally(() => {
        setLoadingTableScreen(false);
      });
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setPeriod(30);
    setFinalDate(undefined);
    setInitialDate(dataHoje);
    setUser("");
    setScreen("");
    setSelectedSystem(null);
    setUserTableData(null);
    setScreenTableData(null);
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setUserTableData(null);
    setScreenTableData(null);
    setSearching(false);
    setLoadingTableScreen(false);
    setLoadingTableUser(false);
  };

  const handleChangeTab = useCallback((event, newValue) => {
    setValueTab(newValue);
  }, []);

  useEffect(() => {
    if (user === "" && screen === "" && period === 30) {
      setClearFilters(false);
    }
  }, [user, screen, period]);

  useEffect(() => {
    if (errorMessageUserDataTable !== "" && !cancelLoading) {
      snackbar.showMessage(errorMessageUserDataTable, {
        severity: "error",
      });
    }

    if (errorMessageScreenDataTable !== "" && !cancelLoading) {
      snackbar.showMessage(errorMessageScreenDataTable, {
        severity: "error",
      });
    }
  }, [cancelLoading, errorMessageUserDataTable, errorMessageScreenDataTable]);

  useEffect(() => {
    handleGetBigNumbers();
    handleGetFiltersData();
    handleGetAccessIndicators();
    handleGetMonthAccessIndicator();
    HandleGetMonthTop10Users();
    HandleGetFeatureMoreUsed();
  }, []);

  return (
    <>
      <HeaderClientes section="Indicadores de Acesso" subsection="Dashboard" />
      <Container maxWidth={false} style={{ marginTop: "-4rem" }}>
        <BignumbersLogs isMobile={itemXS4} data={bigNumbers} />

        <Grid container spacing={2}>
          <Grid item xs={itemXS5} hidden={!monthAccessIndicator}>
            {loadingMonthAccessIndicator ? (
              <Card style={{ padding: "1rem" }}>
                <Skeleton height={320} />
              </Card>
            ) : (
              <CardAccessIndicators data={monthAccessIndicator} type="month" />
            )}
          </Grid>
          <Grid item xs={itemXS5} hidden={!featuresMoreUsed}>
            {loadingFeaturesMoreUsed ? (
              <Card style={{ padding: "1rem" }}>
                <Skeleton height={320} />
              </Card>
            ) : (
              <TopFeaturesChart data={featuresMoreUsed} />
            )}
          </Grid>
          <Grid item xs={itemXS4} hidden={!monthTop10Users}>
            {loadingMonthTop10Users ? (
              <Card style={{ padding: "1rem" }}>
                <Skeleton height={320} />
              </Card>
            ) : (
              <CardTopUsersAccessChart data={monthTop10Users} />
            )}
          </Grid>
        </Grid>

        <Grid container hidden={!accessIndicators}>
          <Grid item xs={12}>
            <CardAccessIndicators data={accessIndicators} type="semester" />
          </Grid>
        </Grid>

        {!loadingTableScreen &&
        !loadingTableUser &&
        !searching &&
        !cancelLoading ? (
          <Grid
            container
            style={{
              marginBottom: "1rem",
              marginTop: !accessIndicators && !isMobile900 ? "9rem" : 0,
            }}
          >
            <Grid item xs={12}>
              <TabContext value={valueTab}>
                <AppBar position="static" color="transparent">
                  <TabList
                    style={{ backgroundColor: "RGBA(255, 193, 197, 0.2)" }}
                    onChange={handleChangeTab}
                    centered
                    scrollButtons="on"
                  >
                    <Tab
                      onClick={() => setShowFilters(false)}
                      style={{ maxWidth: "max-content" }}
                      disabled={loadingTableScreen || searching}
                      label="Telas"
                      value="1"
                    />
                    <Tab
                      onClick={() => setShowFilters(false)}
                      style={{ maxWidth: "max-content" }}
                      disabled={loadingTableUser || searching}
                      label="Usuários"
                      value="2"
                    />
                  </TabList>
                </AppBar>
              </TabContext>
            </Grid>
          </Grid>
        ) : (
          <div
            role="presentation"
            style={
              isMobile900 ? { paddingTop: "0rem" } : { paddingTop: "1rem" }
            }
          />
        )}
        <Grid container>
          <Grid item xs={12}>
            <FilterCard
              handleSearch={handleGetTableData}
              disabled={searching || loadingFilters}
              searching={searching}
              handleClearFilters={handleClearFilters}
            >
              <Grid item xs={itemXS3}>
                <AutoCompleteField
                  label="Tela"
                  loading={loadingFilters || clearFilters}
                  onChange={setScreen}
                  value={screen}
                  options={screensList}
                  disabled={
                    loadingFilters ||
                    searching ||
                    screensList.length === 0 ||
                    screensList.length === 1
                  }
                  optionLabelKey="Tela"
                  optionIdKey="Sistema"
                />
              </Grid>
              <Grid item xs={itemXS3}>
                <AutoCompleteField
                  label="Usuário"
                  loading={loadingFilters || clearFilters}
                  onChange={setUser}
                  value={user}
                  options={usersList}
                  disabled={
                    loadingFilters ||
                    searching ||
                    usersList.length === 0 ||
                    usersList.length === 1
                  }
                  optionIdKey="IdUsuario"
                />
              </Grid>
              <Grid item xs={itemXS3}>
                <AutoCompleteField
                  label="Sistema"
                  loading={loadingFilters || clearFilters}
                  onChange={setSelectedSystem}
                  value={selectedSystem}
                  options={listSystem}
                  disabled={loadingFilters || searching}
                  optionLabelKey="name"
                  optionIdKey="id"
                />
              </Grid>
              <Grid item xs={itemXS3}>
                <PeriodField
                  label="Período"
                  value={period}
                  onChange={setPeriod}
                  disabled={searching}
                  initialDate={initialDate}
                  finalDate={finalDate}
                  setInitialDate={setInitialDate}
                  setFinalDate={setFinalDate}
                  padding
                />
              </Grid>
            </FilterCard>

            <Grid
              item
              xs={12}
              hidden={!searching}
              style={{ marginTop: "1rem" }}
            >
              <LoadingData
                searching={searching}
                onClick={() => handleStopSearching()}
                label="Buscando dados..."
              />
            </Grid>

            <Grid item xs={12} hidden={searching}>
              <Grid
                item
                xs={12}
                hidden={!loadingTableScreen}
                style={{ marginTop: "1rem" }}
              >
                <LoadingData
                  searching={loadingTableScreen}
                  onClick={() => handleStopSearching()}
                  label="Carregando dados de telas..."
                />
              </Grid>
              <Grid
                item
                xs={12}
                hidden={!loadingTableUser}
                style={{ marginTop: "1rem" }}
              >
                <LoadingData
                  searching={loadingTableUser}
                  onClick={() => handleStopSearching()}
                  label="Carregando dados de usuários..."
                />
              </Grid>
            </Grid>
          </Grid>
          {valueTab === "1" &&
            !loadingTableScreen &&
            !loadingTableUser &&
            !searching &&
            !cancelLoading &&
            screenTableData && (
              <TableAccessLogs
                dataTable={screenTableData}
                screen={screen?.Tela}
                sistema={screen?.Sistema}
                idUsuario={user?.IdUsuario}
                datas={getPeriodParams(
                  period,
                  initialDate,
                  finalDate,
                  "screen"
                )}
              />
            )}
          {valueTab === "2" &&
            !loadingTableUser &&
            !loadingTableScreen &&
            !searching &&
            !cancelLoading &&
            userTableData && (
              <TableAccessLogsUser
                screen={screen?.Tela}
                sistema={screen?.Sistema}
                idUsuario={user?.IdUsuario}
                datas={getPeriodParams(
                  period,
                  initialDate,
                  finalDate,
                  "screen"
                )}
                dataTable={userTableData}
                totalRegistros={totalRegistersUser}
                searchUsers={handleGetUsersTableData}
                currentPage={currentPageUser}
                currentSizePerPage={currentSizePerPageUser}
              />
            )}
        </Grid>
      </Container>
    </>
  );
}

export default DashboardIndicadoresDeAcesso;
